import { Pipe, PipeTransform } from '@angular/core';
import { ApiException } from '@api/api';

@Pipe({
  name: 'errorStatusPipe',
  standalone: true,
})
export class ErrorStatusPipe implements PipeTransform {
  transform(value: string | Error | ApiException): number {
    if (value instanceof ApiException) return value.status;

    return 0;
  }
}
